module.exports = __webpack_public_path__ + "static/media/style2-1.80f9b38a.gif";